import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.css'
import '@/styles/variables.scss'
import colors from './colors.js'
import axios from 'axios'
import config from '@/config'

Vue.use(Vuetify)

/**
 * Convert Material-style theme to Vuetify-compatible object
 */
function convertMaterialThemeToVuetify(materialTheme = {}) {
  const p = materialTheme.palette || {}
  return {
    primary: p.primary?.light || '#1f344d',
    secondary: p.secondary?.main || '#2C2C2C',
    main: p.primary?.main,
    accent:  p.primary?.light,
    navbar:  p.primary?.main,
    background: p.background?.default,
    surface: p.background?.surface,
    cards: p.primary?.["800"],
    header: p.primary?.["200"],
    hover: p.background?.hover,
    dividers: p.divider,
    text: {
        primary: '#ffffff',
        secondary: '#b0bec5'
    },
    // fallback custom
    ...materialTheme.custom || {}
  }
}

export async function createVuetifyInstance() {
  let materialTheme = {}
  let isDark = false

  try {
    const res = await axios.get(`${config.auth_url}/api/services/assets/stream/themes/dark.json`)
    const palette = res.data?.palette || {}
    isDark = palette.mode === 'dark'
    materialTheme = convertMaterialThemeToVuetify({ palette })
  } catch (err) {
    materialTheme = {}
    console.warn('[Vuetify] Load server theme failed:', err)
  }

  const lightThemeDefault = {
    ultramarineBlue: colors['ultramarine-blue'],
    mintGreen: colors['mint-green'],
    sunsetOrange: colors['sunset-orange'],
    summerYellow: colors['summer-yellow'],
    softGreen: colors['soft-green'],
    onyx: colors['onyx'],
    slateGrey: colors['slate-grey'],
    mistyGrey: colors['misty-grey'],
    arcticGrey: colors['arctic-grey'],
    primary: '#0033FF',
    backgroundPrimary: colors['arctic-grey'],
    secondary: '#2C2C2C',
    navbar: '#222266',
    sitebar: '#3498db',
    accent: '#0033FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
    button: '#5AC6A1',
    headertext: '#34495f',
    iconbutton: '#5f5f5f',
    white: '#ffffff',
    backgroundInput: '#F1F9FF',
    backgroundHeader: '#8cb9dc',
    darkAccent: '#342cd1',
    primaryOpp: '#0A121A',
    secondaryOpp: '#2C2C2C'
  }

  const defaultDark = {
    // primary: '#0A121A',
    // accent: '#0033FF',
    // secondary: '#2C2C2C',
    // error: '#FF5252',
    // info: '#2196F3',
    // success: '#4CAF50',
    // warning: '#FFC107',
  }
  
  const lightTheme = {
    ...lightThemeDefault,
    ...materialTheme
  }

  const darkTheme = {
    ...defaultDark,
    ...materialTheme
  }

  return new Vuetify({
    theme: {
      dark: isDark,
      options: {
        customProperties: true
      },
      themes: {
        light: lightTheme,
        dark: darkTheme
      }
    },
    icons: {
      iconfont: 'mdi'
    }
  })
}


// WEBPACK FOOTER //
// ./src/plugins/vuetify.js